import React from "react";
import { StyledHeader, StyledLink } from "./style";

const Header = () => (
  <StyledHeader>
    {/* <StyledLink to="/">Steven Roberts</StyledLink> */}
    <p>Product / Art Direction</p>
      <div class="links">
        <p>
          <a href="mailto:contact@stevenroberts.info">contact@stevenroberts.info</a>
        </p>
        {/* <p>
          <a href="https://patternlibrary.substack.com/" target="_blank" rel="noopener noreferrer">@substack</a>
        </p>
        <p>
          <a href="https://www.instagram.com/stevenroberts.artdir/" target="_blank" rel="noopener noreferrer">@instagram</a>
        </p> */}
      </div>
  </StyledHeader>
);

export default Header;